import script from "./SsnDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SsnDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./SsnDisplay.vue?vue&type=style&index=0&id=16101daf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16101daf"]])

export default __exports__